export default class Restaurant {
    uid = 0
    name = ""
    logo = ""
    disabled = 0
    status = RestaurantStatus.Unknown
    continuous_alert = 0
}

export enum RestaurantStatus {
    Unknown,
    Open,
    Busy,
    Closed
}